import React from "react";
import Skeleton from "react-loading-skeleton";

type SkeletonSection = {
  rows?: number;
  showPill?: boolean;
  showAction?: boolean;
};

interface PrimeOrderFlowDetailsSkeletonProps {
  width?: string;
  sections?: SkeletonSection[];
}

const DEFAULT_SECTIONS: SkeletonSection[] = [
  { rows: 2 },
  { rows: 7, showPill: true, showAction: true },
  { rows: 5 },
];

const LABEL_WIDTHS = [88, 104, 72, 120, 96, 80, 112];
const VALUE_WIDTHS = [160, 140, 180, 120, 150, 168, 132];

const SkeletonRow = ({ index }: { index: number }) => (
  <div className="flex flex-row justify-between items-center">
    <Skeleton
      height={12}
      width={LABEL_WIDTHS[index % LABEL_WIDTHS.length]}
    />
    <Skeleton
      height={12}
      width={VALUE_WIDTHS[index % VALUE_WIDTHS.length]}
    />
  </div>
);

const SkeletonCard = ({
  rows = 4,
  showPill = false,
  showAction = false,
}: SkeletonSection) => (
  <div className="flex flex-col py-[8px] px-[12px] space-y-[16px] border border-border-subtle bg-bg-base rounded-lg">
    <div className="flex flex-col gap-3">
      <div className="flex flex-row items-center justify-between">
        <Skeleton height={12} width={110} />
        {showPill && (
          <div className="flex flex-row items-center gap-[6px]">
            <Skeleton height={20} width={64} borderRadius={8} />
            <Skeleton height={20} width={48} borderRadius={8} />
          </div>
        )}
      </div>
      {Array.from({ length: rows }).map((_, index) => (
        <SkeletonRow key={index} index={index} />
      ))}
    </div>
    {showAction && <Skeleton height={28} width={118} borderRadius={6} />}
  </div>
);

const PrimeOrderFlowDetailsSkeleton: React.FC<
  PrimeOrderFlowDetailsSkeletonProps
> = ({ width = "w-full", sections = DEFAULT_SECTIONS }) => {
  return (
    <div
      className={`flex flex-col gap-[12px] mt-[20px] ${width}`}
      style={{ height: "65dvh" }}
    >
      {sections.map((section, index) => (
        <SkeletonCard key={index} {...section} />
      ))}
    </div>
  );
};

export default PrimeOrderFlowDetailsSkeleton;
